import axios from "axios";

const API_BASE = "https://dashboard.lono.co.in/api/sanction-letters";

export const getSanctionLetters = async () => {
  const response = await axios.get(`${API_BASE}`);
  return response.data;
};

export const createSanctionLetter = async (data) => {
  const response = await axios.post(`${API_BASE}`, data);
  return response.data;
};

export const getSanctionLetterById = async (id) => {
  const response = await axios.get(`${API_BASE}/${id}`);
  return response.data;
};

export const updateSanctionLetter = async (id, data) => {
  const response = await axios.put(`${API_BASE}/${id}`, data);
  return response.data;
};

export const deleteSanctionLetter = async (id) => {
  const response = await axios.delete(`${API_BASE}/${id}`);
  return response.data;
};